// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Contact__container-ed1b1c {
  display: flex;
}
.Contact__container-ed1b1c .Contact__icon-container-f85100 {
  display: flex;
  flex: 0 1 auto;
  width: 48px;
  height: 48px;
  border-radius: 100%;
  background-color: var(--brand-primary-40);
}
.Contact__container-ed1b1c .Contact__icon-container-f85100 .Contact__icon-a6984d {
  width: 24px;
  height: 24px;
  margin: auto;
  fill: var(--addition-50);
}
.Contact__container-ed1b1c .Contact__preview-content-ae6373 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-inline-start: var(--indent-16px);
}
.Contact__container-ed1b1c .Contact__preview-content-ae6373 .Contact__name-e82b36 {
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body);
  color: var(--base-110);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 480px;
}
.Contact__container-ed1b1c .Contact__preview-content-ae6373 .Contact__phone-dff5cf {
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle);
  color: var(--chat-bubble-text-secondary);
}

.Contact__button-ea6c30 {
  margin: 8px 0;
  border-radius: 20px !important;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/Message/Payload/Contact/styles.m.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;AACE;EACE,aAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yCAAA;AACJ;AACI;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,wBAAA;AACN;AAGE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uCAAA;AADJ;AAGI;EACE,wBAAA;EACA,wCAAA;EACA,sBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AADN;AAII;EACE,4BAAA;EACA,4CAAA;EACA,wCAAA;AAFN;;AAOA;EACE,aAAA;EACA,8BAAA;AAJF","sourcesContent":[".container {\n  display: flex;\n\n  .icon-container {\n    display: flex;\n    flex: 0 1 auto;\n    width: 48px;\n    height: 48px;\n    border-radius: 100%;\n    background-color: var(--brand-primary-40);\n\n    .icon {\n      width: 24px;\n      height: 24px;\n      margin: auto;\n      fill: var(--addition-50);\n    }\n  }\n\n  .preview-content {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    margin-inline-start: var(--indent-16px);\n\n    .name {\n      font: var(--font-body-2);\n      letter-spacing: var(--font-spacing-body);\n      color: var(--base-110);\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      max-width: 480px;\n    }\n\n    .phone {\n      font: var(--font-subtitle-4);\n      letter-spacing: var(--font-spacing-subtitle);\n      color: var(--chat-bubble-text-secondary);\n    }\n  }\n}\n\n.button {\n  margin: 8px 0;\n  border-radius: 20px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Contact__container-ed1b1c`,
	"icon-container": `Contact__icon-container-f85100`,
	"iconContainer": `Contact__icon-container-f85100`,
	"icon": `Contact__icon-a6984d`,
	"preview-content": `Contact__preview-content-ae6373`,
	"previewContent": `Contact__preview-content-ae6373`,
	"name": `Contact__name-e82b36`,
	"phone": `Contact__phone-dff5cf`,
	"button": `Contact__button-ea6c30`
};
module.exports = ___CSS_LOADER_EXPORT___;
